<template>
  <div class="setComponent">
    <!-- 表单 -->
    <div class="wrap-form">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="180px" size="medium" class="form-setting">
        <el-form-item :label="$i18n.t('wm_lang_60d045')">
          <p class="f12 c_blue">{{ruleForm.userName}}</p>
        </el-form-item>
        <el-form-item :label="$i18n.t('wm_lang_7a615e')">
          <p class="f12 c_blue">{{ruleForm.employeeNum}}</p>
        </el-form-item>
        <el-form-item :label="$i18n.t('wm_lang_193a8c')" prop="telephone">
          <el-input v-model="ruleForm.telephone"></el-input>
        </el-form-item>
        <!-- <el-form-item label="" prop="extension" label-width="0px">
          <el-input v-model="ruleForm.extension" class="el-input130"></el-input>
        </el-form-item> -->
        <el-form-item :label="$i18n.t('wm_lang_92448a')" prop="mobile">
          <el-input v-model="ruleForm.mobile"></el-input>
        </el-form-item>
        <el-form-item :label="$i18n.t('wm_lang_7c2f8e')" prop="fax">
          <el-input v-model="ruleForm.fax"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm('ruleForm')">{{$t("wm_lang_html_be5fbb")}}</el-button>
        </el-form-item>
      </el-form>
    </div>
    <br><br>
  </div>
</template>

<script>

import xmail from '@/api/api';

export default {
  name: 'setComponent',
  data () {
    let telephoneVerify = (rule, value, callback) => {
      let reg=/(^[0][1-9]{2,3}-[0-9]{5,10}$)|(^[1-9][0-9]{5,8}$)/;
      // console.log(reg.test(value));
      if(!reg.test(value)){
        callback(new Error(this.$i18n.t('wm_lang_543586')));
      } else {
        callback();
      }
    };
    let mobileVerify = (rule, value, callback) => {
      let reg=/^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
      // console.log(reg.test(value));
      if(!reg.test(value)){
        callback(new Error(this.$i18n.t('wm_lang_543586')));
      } else {
        callback();
      }
    };
    let faxVerify = (rule, value, callback) => {
      let reg=/^((0\d{2,3})-)(\d{7,8})(-(\d{3,}))?$/;
      if(!reg.test(value)){
        callback(new Error(this.$i18n.t('wm_lang_b0b69e')));
      } else {
        callback();
      }
    };
    return {
      // 表单
      ruleForm: {
        userName: '',
        employeeNum: '',
        telephone: '',
        // extension: '',
        mobile: '',
        fax: ''
      },
      rules: {
        telephone: [
          // { min: 7, max: 13, trigger: "blur" },
          { pattern: /^[0-9-()+]{1,32}$/, message: this.$i18n.t('wm_lang_543586'), trigger: "blur" }
        ],
        // extension: [
        //   { max: 6, message: this.$i18n.t('wm_lang_e3d664'), trigger: "blur" },
        //   { pattern: /^[0-9]*$/, message: this.$i18n.t('wm_lang_e3d664'), trigger: "blur" }
        // ],
        mobile: [
          // { min: 7, max: 13, trigger: "blur" },
          { pattern: /^[0-9-()+]{1,32}$/, message: this.$i18n.t('wm_lang_18d771'), trigger: "blur" }
        ],
        fax: [
          // { min: 7, max: 13, trigger: "blur" },
          { pattern: /^[0-9-()+]{1,32}$/, message: this.$i18n.t('wm_lang_b0b69e'), trigger: "blur" }
        ]
      }
    }
  },
  mounted() {
    let self = this;
    (function (api, enums, pms) {
      api.UserInfo.queryUserInfo({}, function (res) {
        // console.log(res)
        // let telArr = [];
        // let extension = ''
        // if(res.data.data.tel) {
        //   telArr = res.data.data.tel.split('-');
        // }
        // if(telArr.length > 1) {
        //   let temp = telArr.pop()
        //   if(temp.length <= 6) {
        //     extension = temp;
        //   }
        // }
        self.ruleForm.userName = res.data.data.name;
        self.ruleForm.employeeNum = res.data.data.employeeId;
        self.ruleForm.telephone = res.data.data.tel;
        // self.ruleForm.telephone = telArr.join('-');
        // self.ruleForm.extension = extension;
        self.ruleForm.mobile = res.data.data.mobile;
        self.ruleForm.fax = res.data.data.fax;
      })
    })(xmail.api, xmail.enums, xmail.pms);
  },
  methods: {
    // 表单
    // submitForm() {
    //   let self = this;
    //   (function (api, enums, pms) {
    //     console.log(pms.UserInfo.saveUserInfoParamBuilder)
    //     let pm = pms.UserInfo.saveUserInfoParamBuilder();
    //     pm.name = self.userName;
    //     pm.tel =  self.telephone;
    //     pm.mobile =  self.mobile;
    //     pm.fax =  self.fax;
    //     api.UserInfo.saveUserInfo(pm, function (res) {
    //       console.log(res)
    //     })
    //   })(xmail.api, xmail.enums, xmail.pms);
    // }
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let self = this;
          (function (api, enums, pms) {
            // let fullTel = ''
            // if(self.ruleForm.extension) {
            //   fullTel = self.ruleForm.telephone + '-' + self.ruleForm.extension;
            // } else {
            //   fullTel = self.ruleForm.telephone;
            // }
            let pm = pms.UserInfo.saveUserInfoParamBuilder();
            pm.name = self.ruleForm.userName;
            // pm.tel =  fullTel;
            pm.tel =  self.ruleForm.telephone;
            pm.mobile =  self.ruleForm.mobile;
            pm.fax =  self.ruleForm.fax;
            api.UserInfo.saveUserInfo(pm, function (res) {
              console.log(res)
              if(res.data.code === 0) {
                self.$message({
                  type: 'success',
                  message: self.$i18n.t('wm_lang_33130f')+'!'
                });
              }
            })
          })(xmail.api, xmail.enums, xmail.pms);
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 .setComponent{padding:10px;}
 .setComponent .title .el-divider--horizontal{margin:10px 0;}
</style>



// WEBPACK FOOTER //
// src/components/views/setBox/userInfo.vue